import { useSession } from '@/lib/auth-client'
import { User } from 'lucide-react'
import { LocaleToggle } from '@/components/ui/LocaleToggle'
import { WorkspaceSwitcher } from './WorkspaceSwitcher'

export function Topbar() {
  const { data: session } = useSession()
  const user = session?.user

  return (
    <header className="glass-sm flex items-center justify-between px-6 py-3.5 border-b border-white/10 rounded-none">
      <div className="flex items-center gap-3">
        <WorkspaceSwitcher />
        <LocaleToggle />
      </div>
      {user && (
        <div className="flex items-center gap-3">
          <div className="text-right">
            <p className="text-sm font-medium text-white leading-none">{user.name}</p>
            <p className="text-xs text-white/40 mt-0.5">{user.email}</p>
          </div>
          <div className="w-8 h-8 rounded-full glass flex items-center justify-center">
            {user.image ? (
              <img src={user.image} alt={user.name} className="w-8 h-8 rounded-full object-cover" />
            ) : (
              <User size={16} className="text-white/60" />
            )}
          </div>
        </div>
      )}
    </header>
  )
}
